<template>
    <button class="btn btn-sm text-secondary p-0 pr-2" v-on="listeners" v-bind="attrs">
        <font-awesome-icon :icon="['fas', 'arrow-left']" role="button" />
    </button>
</template>

<script>
    export default {
        computed: {
            attrs() {
                const { state, ...attrs } = this.$attrs;
                return attrs;
            },
            listeners() {
                const { input, ...listeners } = this.$listeners;
                return listeners;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .go-back-icon-button {
        border: none;
        background: transparent;
        padding: 0;
        outline: none;
    }
</style>
